import { GAME, totalHeight } from "../config/gameConfig";
import { cellsFor } from "./Pieces";
import type { ActivePiece, Cell, PieceType, Rotation } from "./types";

export class Board {
  readonly cells: Cell[][];

  constructor() {
    this.cells = Array.from({ length: totalHeight }, () => Array<Cell>(GAME.width).fill(null));
  }

  reset(): void {
    for (const row of this.cells) row.fill(null);
  }

  canPlace(piece: ActivePiece, x = piece.x, y = piece.y, rotation: Rotation = piece.rotation): boolean {
    return cellsFor(piece.type, rotation).every((cell) => {
      const boardX = x + cell.x;
      const boardY = y + cell.y;
      if (boardX < 0 || boardX >= GAME.width || boardY >= totalHeight) return false;
      return boardY < 0 || this.cells[boardY]?.[boardX] === null;
    });
  }

  lock(piece: ActivePiece): boolean {
    let overflow = false;
    for (const cell of cellsFor(piece.type, piece.rotation)) {
      const x = piece.x + cell.x;
      const y = piece.y + cell.y;
      if (y < 0) overflow = true;
      else if (this.cells[y]) this.cells[y]![x] = piece.type;
    }
    return overflow;
  }

  clearFullLines(): number[] {
    const cleared: number[] = [];
    for (let y = totalHeight - 1; y >= 0; y -= 1) {
      if (this.cells[y]!.every((cell) => cell !== null)) {
        cleared.push(y);
        this.cells.splice(y, 1);
        this.cells.unshift(Array<Cell>(GAME.width).fill(null));
        y += 1;
      }
    }
    return cleared;
  }

  setCell(x: number, y: number, type: PieceType | null): void {
    if (this.cells[y] && x >= 0 && x < GAME.width) this.cells[y]![x] = type;
  }
}
